import { useState } from "react";
import { Link } from "react-router-dom";
import { api, formatApiError } from "@/lib/api";
import { Sparkles, ArrowLeft, MailCheck } from "lucide-react";
import { toast } from "sonner";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [done, setDone] = useState(false);
  const [busy, setBusy] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.post("/auth/forgot-password", { email });
      setDone(true);
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen bg-background grid-noise flex items-center justify-center p-4">
      <Link to="/login" className="absolute top-6 left-6 flex items-center gap-2 font-bold hover:underline">
        <ArrowLeft className="w-4 h-4" /> Back to login
      </Link>

      <div className="w-full max-w-md">
        <div className="text-center mb-6">
          <div className="inline-flex items-center gap-2 mb-4">
            <div className="w-11 h-11 bg-primary border-2 border-foreground rounded-md shadow-brutal flex items-center justify-center">
              <Sparkles className="w-6 h-6" strokeWidth={2.5} />
            </div>
            <span className="font-heading font-extrabold text-2xl">DmFlio</span>
          </div>
          <h1 className="text-3xl font-extrabold">Reset your password</h1>
          <p className="text-sm text-muted-foreground mt-1 font-medium">We'll send a reset link to your email.</p>
        </div>

        {done ? (
          <div className="brutal bg-mint p-6 text-center" data-testid="forgot-success">
            <MailCheck className="w-10 h-10 mx-auto mb-3" strokeWidth={2.5} />
            <h2 className="font-heading font-extrabold text-xl">Check your inbox</h2>
            <p className="text-sm font-medium mt-1">If an account exists for <strong>{email}</strong>, a reset link is on the way.</p>
            <p className="text-xs text-muted-foreground font-medium mt-3">In dev mode, the reset link is printed to the backend console.</p>
            <Link to="/login" className="mt-5 inline-block px-4 py-2 bg-white border-2 border-foreground rounded-md font-bold shadow-brutal-sm">Back to login</Link>
          </div>
        ) : (
          <form onSubmit={onSubmit} className="brutal bg-white p-6 space-y-4">
            <div>
              <label className="text-xs font-bold uppercase tracking-wider mb-1.5 block">Email</label>
              <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} data-testid="forgot-email" className="brutal-input w-full" placeholder="you@example.com" />
            </div>
            <button type="submit" disabled={busy} data-testid="forgot-submit" className="w-full bg-primary border-2 border-foreground rounded-md py-3 font-bold shadow-brutal-sm hover:shadow-brutal hover:-translate-y-0.5 transition-all disabled:opacity-50">
              {busy ? "Sending…" : "Send reset link"}
            </button>
          </form>
        )}
      </div>
    </div>
  );
}
